'use client';

import { faMessageSmile } from '@fortawesome/pro-light-svg-icons';
import Image from 'next/image';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';
import { useState } from 'react';

import { PhoneUpdateInput } from './phone-update-input.component';

import { Button } from '@/components/ui/button/button.component';
import telemedSVG from '@/assets/guide/telemed.svg?url';
import { Link } from '@/components/ui/link/link.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { useWhatsappLinkWithAnalytics } from '@/hooks/use-whatsapp/use-whatsapp-link-with-analytics.hook';
import { phonePatientSac } from '@/utils/consts/sac.consts';
import { patientSacWhatsappMessage } from '@/utils/consts/cta-whatsapp-messages.consts';

interface TelemedSupportProps {
  email: string;
  professionalName: string;
  phone: string;
}

export default function TelemedSupport({ email, professionalName, phone }: TelemedSupportProps) {
  const { url } = useWhatsappLinkWithAnalytics(phonePatientSac, patientSacWhatsappMessage);
  const [currentPhone, setCurrentPhone] = useState(phone);

  return (
    <div
      data-testid={DataTestIdEnum.APPOINTMENT_CARD_TELEMED_SUPPORT}
      className="flex flex-col gap-5 border border-success-300 rounded-xxl p-4"
    >
      <div className="flex items-center gap-4">
        <Image width={80} height={42} src={telemedSVG} alt="Guia avulsa" />
        <Typography variant={TypographyVariant.BODY_TEXT} className="text-lg font-bold text-gray-900">
          Como vai funcionar a teleconsulta?
        </Typography>
      </div>

      <Typography>
        {professionalName}
        {' '}
        iniciará o atendimento próximo ao horário agendado. Em alguns casos, pode haver um pequeno atraso devido à
        agenda médica. Pedimos que permaneça disponível e acompanhe o seu celular
        {' '}
        <strong>{currentPhone}</strong>
        {' '}
        e o e-mail
        {' '}
        <strong>{email}</strong>
      </Typography>
      <Typography>
        Se o seu celular mudou, clique no botão abaixo para atualizar:
      </Typography>
      <PhoneUpdateInput defaultValue={currentPhone} onPhoneUpdate={setCurrentPhone} />
      <Button asChild startIcon={faMessageSmile} variant="secondary">
        <Link prefetch={false} href={url} target="_blank">
          Preciso de ajuda
        </Link>
      </Button>
    </div>
  );
}
